import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Popup,
    PopupTitle,
    PopupContent,
    Select,
    Option,
    PopupFooter,
    Button,
    FormButtons
} from "@tv2no/ui-react";
import { copyPersonList } from "../../../api/services/personList";

const Copy = ({ personList, yearList, setShowCopyPrompt }) => {
    const navigate = useNavigate();
    const [busyCopying, setBusyCopying] = useState(false);
    const [copyToTaxYear, setCopyToTaxYear] = useState(null);

    const handleCopyList = () => {
        // Busy on
        setBusyCopying(true);

        // Send request
        copyPersonList(personList.id, copyToTaxYear).then((newList) => {
            navigate(`/lists/entry/${newList.id}`);
            window.location.reload();
        });
    };

    return (
        <Popup>
            <PopupTitle subtitle={personList.name}>Kopier listen</PopupTitle>
            <PopupContent>
                <Select
                    placeholder="Kopier til skatteår"
                    value={copyToTaxYear}
                    onChange={setCopyToTaxYear}
                >
                    {yearList &&
                        yearList.map((entry) => (
                            <Option key={entry.year} value={entry.year}>
                                {entry.year}
                            </Option>
                        ))}
                </Select>
            </PopupContent>
            <PopupFooter>
                <FormButtons>
                    <Button
                        type="submit"
                        color="primary"
                        onClick={handleCopyList}
                        busy={busyCopying}
                    >
                        Kopier listen
                    </Button>
                    <Button onClick={() => setShowCopyPrompt(false)} disabled={busyCopying}>
                        Avbryt
                    </Button>
                </FormButtons>
            </PopupFooter>
        </Popup>
    );
};

export default Copy;
